import React, { useEffect, useState } from 'react';
import ReactDom from "react-dom";

import _ from 'lodash';
import cx from 'classnames';

import { MenuButton } from '../menuButton';
import { AnimationComponent } from '../../../Animations';

import styles from './menuContainer.module.scss';
import { getColorsConfig } from '../../../../components/AssetViewer/helper/cssHelper';

const MenuContainerWidgetComponent = ({ className, style, widgetProps, breakpoint, parentRef, parentStyle }) => {
  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');
  const properties = _.get(widgetProps, 'properties', {});
  const deviceProperties = _.get(properties, `${breakpoint}`, {});
  const trayAlignment = _.get(widgetProps, `properties.${breakpoint}.trayAlignment.position`);
  const layout = _.get(widgetProps, `properties.${breakpoint}.layout`);
  const [iconState, setIconState] = useState('regular');
  const animation = _.get(widgetProps, `properties.${breakpoint}.animation`) || {};

  const [expand, setExpand] = useState(false);

  const menuContent = _.get(widgetProps, 'content');

  var iconStyle = getIconStyles(properties, iconState);

  const widgetStyle = {
    ...style,
    ...getStyles(widgetProps, breakpoint)
  }

  const handleOnClick =(e)=>{
    setExpand(!expand);
  }

  return (
    <React.Fragment>
      <div id={id}
        className={cx(className, { [styles.menuContainer]: breakpoint === 'desktop' }, { [styles.mobileView]: breakpoint === 'mobile' }, 'cs_menucontainer')}
        style={widgetStyle}
        data-widget-id={id}
        tabIndex={0}
        onClick={handleOnClick}
        data-widget-type={type}
      >
        {breakpoint === 'mobile' &&
          <AnimationComponent {...animation}>
            <div
              style={{ height: layout.height }}
              className={styles.wrapper}
            >
              <div style={iconStyle} className={styles.hamburger}>
                <i className={cx({ ['cleverstory-menu']: !expand }, { ['cleverstory-close']: expand }, styles.menuIcon)} />
              </div>
            </div>
          </AnimationComponent>
        }

        {breakpoint === 'desktop' &&
          <MenuButton
            menuContent={menuContent}
            breakpoint={breakpoint}
            active='regular'
            widgetProps={widgetProps}
          />
        }
      </div>
      {(breakpoint === 'mobile' && parentRef.current) &&
        ReactDom.createPortal(
          <div style={{top: `${parentStyle.height}`}} className={cx(styles.menuListView,
            {[styles.expandView]: expand},
            {[styles.alignmentLeft]: trayAlignment === 'left' },
            {[styles.alignmentRight]: trayAlignment === 'right' },
          )}
          >
            <MenuButton
              menuContent={menuContent}
              breakpoint={breakpoint}
              active='regular'
              widgetProps={widgetProps}
            />
          </div>,
          parentRef.current
        )
      }
    </React.Fragment>
  );
};

function getStyles(widget, breakpoint) {
  var styles = {};

  if (breakpoint === 'desktop') {
    const width = parseFloat(_.get(widget, `properties.${breakpoint}.layout.width`, 100));
    const height = parseFloat(_.get(widget, `properties.${breakpoint}.layout.height`, 100))
    styles = {
      ...styles,
      maxWidth: width,
      height: height
    }
  }

  return styles;
}

function getIconStyles(properties, active) {
  var styles = {};

  if (!properties) {
    return styles;
  }

  const defaultProperties = _.get(properties, 'mobile');
  const defaultStyles = _.get(defaultProperties, `${active}.menuStyles`, {});

  //font-color
  const colorRgb = _.get(defaultStyles, `font.color`, null);
  const color = getColorStyles(colorRgb);
  styles = {
    ...styles,
    ...color
  }

  //background
  const backgroundRgb = _.get(defaultStyles, `background`, null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb);
  }

  styles['background'] = background;

  //border
  const border = _.get(defaultStyles, 'border', {});
  const borderColor = _.get(defaultStyles, `border.color`, null);

  const borderStyle = getBorderStyles(border, borderColor);
  styles = {
    ...styles,
    ...borderStyle
  }

  //alignment
  styles['justifyContent'] = 'center';
  styles['textAlign'] = 'center';

  return styles;

}

export function getColorStyles(value) {
  if (!value) {
    return null;
  }

  const colorRgb = value;

  var color = 'inherit';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  var styles = {
    color: color
  };

  return styles;
}

export function getBorderStyles(value, colorRgb) {
  if (!value) {
    return null;
  }

  var styles = {};
  const topLeft = _.get(value, 'radius.topLeft', null);
  const topRight = _.get(value, 'radius.topRight', null);
  const bottomLeft = _.get(value, 'radius.bottomLeft', null);
  const bottomRight = _.get(value, 'radius.bottomRight', null);

  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }

  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }

  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }

  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }

  var color = 'transparent';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  styles['borderColor'] = color;

  const borderWidthString = _.get(value, 'width', null);
  var borderWidget = parseInt(borderWidthString) + 'px';

  styles['borderWidth'] = borderWidget;

  return styles;
}

const menuContainerWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const MenuContainerWidget = React.memo(MenuContainerWidgetComponent, menuContainerWidgetEquals);
